const projects = [
  {
    id: "assemble",
    name: "Assemble",
    type: "Cross-platform Mobile App",
    timeline: "August 2020 - January 2021",
    descriptions: [
      "Assemble is a local mobile app made for Singaporeans which allows them to form meaningful relationship. It features new daily matches, chat functionality, in-app notifications and functionality to report users for inappropriate behaviours.",
      "This project was built amidst my Year 4 Semester 2 in NUS. This project was meant to be fun and also to be an opportunity to revisit the technologies that I used during my internship in Webpuppies.",
      "This server to this project has been taken down since 28 May 2021.",
    ],
    devTools: [
      "NativeScript Vue",
      "ExpressJS",
      "Firebase services",
      "AWS",
      "NginX",
    ],
    playstoreUrl:
      "https://play.google.com/store/apps/details?id=org.chalkboystudio.rootly",
    appstoreUrl:
      "https://apps.apple.com/us/app/assemble-local-dating-app/id1553270546",
    weburl: "",
    sourceCodeLink: "",
    images: [
      "/images/assemble/low_res/assemble_main.png",
      "/images/assemble/low_res/assemble_3.png",
      "/images/assemble/low_res/assemble_4.png",
      "/images/assemble/low_res/assemble_5.png",
      "/images/assemble/low_res/assemble_6.png",
      "/images/assemble/low_res/assemble_7.png",
      "/images/assemble/low_res/assemble_8.png",
      "/images/assemble/low_res/assemble_9.png",
      "/images/assemble/low_res/assemble_10.png",
      "/images/assemble/low_res/assemble_11.png",
    ],
  },
  {
    id: "emaily",
    name: "Emaily",
    type: "Web App",
    timeline: "Feb 2020",
    descriptions: [
      "Emaily is a web app that allows user to mass send and track responses of survey emails. Users are logged in using Google Authentication, and payment is done via Stripe API.",
      "This project was built as part of a full stack web development course by Stephan Grider.",
    ],
    devTools: [
      "ReactJS",
      "Redux",
      "MongoDB",
      "ExpressJS",
      "OAuth",
      "Stripe",
      "Heroku",
    ],
    playstoreUrl: "",
    appstoreUrl: "",
    weburl: "https://murmuring-thicket-55187.herokuapp.com",
    sourceCodeLink: "https://github.com/francislow/emailyy",
    images: [
      "/images/emailyy/low_res/emailyy_main.png",
      "/images/emailyy/low_res/emailyy_2.png",
      "/images/emailyy/low_res/emailyy_3.png",
      "/images/emailyy/low_res/emailyy_4.png",
      "/images/emailyy/low_res/emailyy_5.png",
      "/images/emailyy/low_res/emailyy_6.png",
    ],
  },
  {
    id: "unmix",
    name: "Unmix",
    type: "Native Android App",
    timeline: "August 2019",
    descriptions: [
      "A native android application that allows user to store, label and manage pictures locally separated from the phone's inbuilt gallery.",
    ],
    devTools: ["Android", "Java", "SQLite", "Android SDK"],
    playstoreUrl:
      "https://play.google.com/store/apps/details?id=com.chalkboystudios.franc.unmix",
    appstoreUrl: "",
    weburl: "",
    sourceCodeLink: "https://github.com/francislow/unmix-photo-gallery",
    images: [
      "/images/unmix/low_res/unmix_main.png",
      "/images/unmix/low_res/unmix_2.png",
      "/images/unmix/low_res/unmix_3.png",
      "/images/unmix/low_res/unmix_4.png",
      "/images/unmix/low_res/unmix_5.png",
      "/images/unmix/low_res/unmix_6.png",
    ],
  },
  {
    id: "poofers",
    name: "Poofers",
    type: "Native Android App",
    timeline: "March 2017",
    descriptions: [
      "A native android 2D arcade game application developed using libGDX, a Java game development framework.",
    ],
    devTools: ["Android", "Java", "libGDX", "InkScape", "Android SDK"],
    playstoreUrl:
      "https://play.google.com/store/apps/details?id=com.chalkboyygames",
    appstoreUrl: "",
    weburl: "",
    sourceCodeLink: "https://github.com/francislow/poofers",
    images: [
      "/images/poofers/low_res/poofers_main.png",
      "/images/poofers/low_res/poofers_2.png",
      "/images/poofers/low_res/poofers_3.png",
      "/images/poofers/low_res/poofers_4.png",
      "/images/poofers/low_res/poofers_5.png",
      "/images/poofers/low_res/poofers_6.png",
      "/images/poofers/low_res/poofers_7.png",
    ],
  },
];

export default projects;
